import React from 'react';
import { render } from '@testing-library/react';
import { Headline } from './Headline';

describe('Headline', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Headline
				className="m-x-8 m-y-4"
				data-auto-sel="automation-selector"
			>
				Lorem ipsum dolor sit amet
			</Headline>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
